import { DeviceInUseError, MicPermissionError, NoMicDevicesError } from '../../types';
import { getMicPermission } from './getMicPermission';

export { DeviceInUseError, MicPermissionError, NoMicDevicesError };

export const checkMicPermissionAndDevices = async (): Promise<void> => {
  await getMicPermission();
  const devices = await navigator.mediaDevices.enumerateDevices();
  const audioInputDevices = devices.filter((device) => device.kind === 'audioinput');

  if (audioInputDevices.length === 0) {
    throw new NoMicDevicesError('no mic devices available');
  }
};
